var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BarStream"},[_c('div',{staticClass:"status hover"},[_c('button',{on:{"click":_vm.onAudioClick}},[_c('span',{class:_vm.getIcon}),_c('span',[_vm._v(_vm._s(_vm.getOnAir))])])]),_c('div',{staticClass:"title"},[_c('marquee-conditional',{attrs:{"content":_vm.getTitle}})],1),_c('div',{staticClass:"spacer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }